"use client";

import { Smartphone } from "lucide-react";
import { useTranslations } from "next-intl";
import { storeUrlForPlatform } from "@award-party/shared";
import { useGetApp } from "./get-app-provider";

const CTA_CLASS =
  "mt-6 inline-flex cursor-pointer items-center gap-2 text-sm font-medium text-(--mk-cream-60) no-underline transition-colors hover:text-(--mk-cream)";

export function MarketingGetAppCta() {
  const t = useTranslations("Home");
  const {
    canGetApp,
    canInstallOnDesktop,
    platform,
    store,
    iosUrl,
    androidUrl,
    openDesktopInstall,
    trackStoreClick,
  } = useGetApp();

  if (canInstallOnDesktop) {
    return (
      <button type="button" onClick={openDesktopInstall} className={CTA_CLASS}>
        <Smartphone className="h-4 w-4 text-(--mk-gold)" />
        {t("installTheApp")}
      </button>
    );
  }

  if (!canGetApp) {
    return null;
  }

  const storeUrl = storeUrlForPlatform(platform, { iosUrl, androidUrl });

  if (store && storeUrl) {
    return (
      <a
        href={storeUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={CTA_CLASS}
        onClick={() => trackStoreClick(store, "marketing")}
      >
        <Smartphone className="h-4 w-4 text-(--mk-gold)" />
        {store === "ios" ? t("getOnAppStore") : t("getOnPlayStore")}
      </a>
    );
  }

  return null;
}
